import { Component, Input } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Event,
  NavigationEnd,
  NavigationStart,
  RouterLink,
} from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { BreadcrumbModel } from '../../../models/breadcrumb.model';
import { ParamsModel } from '../../../pages/match-details/models/params.model';
import { GenericService } from '../../../services/generic.services';
import { SportsService } from '../../../services/sport.service';
import { ScoresSportsService } from '../../../services/scores-sports.service';
import { UtilitiesService } from '../../../services/utilities.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { TranslationService } from '@/app/services/translation.service';
import { ESportsApiV1 } from '@/app/models/sports.model';
import { ELanguage, getSportRouteByLanguage } from '@/app/utils';
import {
  ROUTE_FOOTBALL,
  ROUTE_FOOTBALL_EN,
  ROUTE_SPORTS,
  ROUTE_SPORTS_COMPETITIONS,
  ROUTE_SPORTS_COMPETITIONS_EN,
  ROUTE_SPORTS_EN,
} from '@/app/routes';
import { normalizeRoute } from '@/tools/utils/utils';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [CommonModule, NzBreadCrumbModule, TranslateModule, RouterLink],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {
  urlIcon = environment.urlIcon;
  @Input() infoBreadcrumb: any = {};

  breadcrumb: BreadcrumbModel = {} as BreadcrumbModel;
  today: any = '';

  private params: ParamsModel = {} as ParamsModel;

  isCompetition: boolean = false;

  loading: boolean = true;

  private urlMatch: boolean = false;
  selectedSport: string = 'Futbol';

  constructor(
    private readonly translateService: TranslateService,
    private readonly _activateRoute: ActivatedRoute,
    private readonly sportsServices: SportsService,
    private readonly scoreService: ScoresSportsService,
    private readonly router: Router,
    public utilityService: UtilitiesService,
    private genericServices: GenericService,
    private translationService: TranslationService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.urlMatch = event.url.includes('/partido/');
      } else if (event instanceof NavigationStart) {
        this.urlMatch = event.url.includes('/partido/');
      }
    });
  }

  ngOnInit(): void {
    this.today = this.genericServices.getCurrentDate();
    switch (this.sportsServices.getSelectedSport()) {
      case ESportsApiV1.FOOTBALL:
        this.selectedSport = 'Football';
        break;
      case ESportsApiV1.BASKETBALL:
        this.selectedSport = 'Basket';
        break;
      case ESportsApiV1.BASEBALL:
        this.selectedSport = 'Baseball';
        break;
      case ESportsApiV1.VOLLEYBALL:
        this.selectedSport = 'Voleyball';
        break;
      case ESportsApiV1.HOCKEY:
        this.selectedSport = 'Hockey';
        break;
      case ESportsApiV1.HANDBALL:
        this.selectedSport = 'Handball';
        break;
      case ESportsApiV1.AMERICAN_FOOTBALL:
        this.selectedSport = 'AmericanFutbol';
        break;
      case ESportsApiV1.TENNIS:
        this.selectedSport = 'Tennis';
        break;
      default:
        break;
    }

    this._activateRoute.params.subscribe((params: any) => {
      if (
        params &&
        Object.keys(params).length > 0 &&
        'idCompetition' in params
      ) {
        // this.breadcrumb.sport = this.translateService.instant(
        //   `Sports.${this.selectedSport}`
        // );

        this.translateService
          .get(`Sports.${this.selectedSport}`)
          .subscribe((translation: string) => {
            this.breadcrumb.sport = translation;
          });
        this.breadcrumb.sportLogo = this.sportsServices.searchSport(
          this.sportsServices.getSelectedSport()
        )?.urlIcon;
        this.params = params;
        this.isCompetition = true;
        this.loadDataBreadcrumb(this.params);
      } else {
        this.breadcrumb.sport = this.translateService.instant(
          this.infoBreadcrumb.sport
        );
        this.breadcrumb.sportLogo = this.sportsServices.searchSport(
          this.infoBreadcrumb.icon
        ).urlIcon;
        this.breadcrumb.competition = this.infoBreadcrumb.name;
        this.breadcrumb.competitionLogo = this.infoBreadcrumb.logo;
        this.loading = false;
      }
    });
  }

  private loadDataBreadcrumb(params: ParamsModel) {
    this.scoreService
      .getCompetitionById(params.idCompetition)
      .subscribe((response: any) => {
        if (response.status) {
          this.breadcrumb.idCompetition = params.idCompetition;
          this.breadcrumb.competition = response.competition.name;
          this.breadcrumb.competitionLogo = response.competition.logo;
          this.breadcrumb.nameStage = response.competition.nameStage;
          this.breadcrumb.country = response.competition.country;
          this.breadcrumb.logoCountry = response.competition.logoCountry;
          this.loading = false;
        }
      });
  }

  transform(text: string, length: number = 50, suffix: string = '...'): string {
    if (text.length > length)
      return text.substring(0, length).trim().concat(suffix);

    return text;
  }

  openCompetition(): string {
    if (this.translationService.getCurrentLanguage() === ELanguage.EN) {
      // this.router.navigate([
      //   ROUTE_SPORTS_COMPETITIONS_EN.replace(
      //     ':sport',
      //     getSportRouteByLanguage(
      //       ELanguage.EN,
      //       this.sportsServices.getSelectedSport()
      //     )
      //   )
      //     .replace(
      //       ':country',
      //       normalizeRoute(
      //         this.utilityService.getCountry(this.breadcrumb?.country)
      //       )
      //     )
      //     .replace('leagueName', normalizeRoute(this.breadcrumb.competition))
      //     .replace(':idCompetition', this.breadcrumb.idCompetition),
      // ]);
      return `/${ROUTE_SPORTS_COMPETITIONS_EN.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.EN,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(
          ':country',
          normalizeRoute(
            this.utilityService.getCountry(this.breadcrumb?.country)
          )
        )
        .replace('leagueName', normalizeRoute(this.breadcrumb.competition))
        .replace(':idCompetition', this.breadcrumb.idCompetition)}`;
    } else {
      // this.router.navigate([
      //   ROUTE_SPORTS_COMPETITIONS.replace(
      //     ':sport',
      //     getSportRouteByLanguage(
      //       ELanguage.ES,
      //       this.sportsServices.getSelectedSport()
      //     )
      //   )
      //     .replace(
      //       ':country',
      //       normalizeRoute(
      //         this.utilityService.getCountry(this.breadcrumb?.country)
      //       )
      //     )
      //     .replace('leagueName', normalizeRoute(this.breadcrumb.competition))
      //     .replace(':idCompetition', this.breadcrumb.idCompetition),
      // ]);
      return `/${ROUTE_SPORTS_COMPETITIONS.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.ES,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(
          ':country',
          normalizeRoute(
            this.utilityService.getCountry(this.breadcrumb?.country)
          )
        )
        .replace('leagueName', normalizeRoute(this.breadcrumb.competition))
        .replace(':idCompetition', this.breadcrumb.idCompetition)}`;
    }
  }

  openDashboard(): string {
    const sport = this.sportsServices.getSelectedSport();

    if (sport) {
      // this.router.navigate([
      //   sport === 'Futbol'
      //     ? `/${this.translationService.getInitPathFootball()}`
      //     : `${sport}/todos-los-partidos`,
      // ]);
      return this.translationService.getCurrentLanguage() === ELanguage.EN
        ? `/${ROUTE_SPORTS_EN.replace(
            ':sport',
            getSportRouteByLanguage(
              ELanguage.EN,
              this.sportsServices.getSelectedSport()
            )
          )}`
        : `/${ROUTE_SPORTS.replace(
            ':sport',
            getSportRouteByLanguage(
              ELanguage.ES,
              this.sportsServices.getSelectedSport()
            )
          )}`;
    } else {
      this.sportsServices.setSelectedSport(ESportsApiV1.FOOTBALL);
      return this.translationService.getCurrentLanguage() === ELanguage.EN
        ? `/${ROUTE_FOOTBALL_EN}`
        : `/${ROUTE_FOOTBALL}`;
      // this.router.navigate(['Futbol/todos-los-partidos']);
    }
  }
}
